import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { ILocationService, LocationProps, Location, ITelemetryService } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
import { formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for location module related message requests.
 */
export class LocationMessageHandler extends BaseMessageHandler {
  constructor(
    protected appSdkHost: HostedWebContentSdkService,
    protected locationService?: ILocationService,
    protected telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.location.getLocation,
      (_, params: LocationProps) => formulateSdkResponse(params, this.locationService!.getLocation),
      {
        errorCallback: (error, scenario) => onSdkError(SdkMessageTypes.location.getLocation, error, scenario),
      }
    );
    this.registerHandler(
      SdkMessageTypes.location.showLocation,
      (_, params: Location) => formulateSdkResponse(params, this.locationService!.showLocation),
      {
        errorCallback: (error, scenario) => onSdkError(SdkMessageTypes.location.showLocation, error, scenario),
      }
    );
  }

  protected validateDependencies() {
    if (!this.locationService) {
      throw 'No locationService provided';
    }
  }
}
